export default props => (
  <article className="slds-card">
    <div className="slds-card__header slds-grid">
      {props.header}
    </div>
    <div className="slds-card__body slds-card__body_inner">
      {props.children}
    </div>
    {props.footer}

    <style jsx>{`
      .slds-card {
        margin: 1.5rem 0.75rem;
      }
    `}</style>
  </article>
)
